import styled from 'styled-components';

export const ModalContent = styled.div`
  p {
    margin-bottom: 20px;
  }
`;
